import { createApiInstance } from '../utils/createApiInstance';
import { getAPIHost } from '@rsos/utils/metaTags';

const baseURL = `${getAPIHost()}/v1/scorpius`;

const instance = createApiInstance(baseURL);

export default instance;
